import script from "./OrderKindsOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderKindsOverview.vue?vue&type=script&setup=true&lang=js"

import "./OrderKindsOverview.vue?vue&type=style&index=0&id=57f6346a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f6346a"]])

export default __exports__